import React, { useEffect, useMemo } from 'react';
import { Col, Row, Card, Modal, Button, Spinner, Alert } from 'react-bootstrap';
import { addDays, weeksToDays, startOfWeek, format } from 'date-fns';
import { useState } from 'react';
import ClassService from './classes/ClassService';
import { useBreakpoints } from 'hooks/useBreakpoints';
import Avatar, { AvatarGroup } from 'components/common/Avatar';
import defaultAvatar from 'assets/img/team/avatar.png';
const ClassCard = ({ event, onClick, handleRefreshEvents,multiple=false }) => {
  // Map color names to Bootstrap/CSS classes
  const colorClasses = {
    gray: 'bg-secondary',
    green: 'bg-success',
    red: 'bg-danger',
    orange: 'bg-warning',
    success: 'bg-success',
    info: 'bg-info',
    warning: 'bg-warning',
    danger: 'bg-danger',
    primary: 'bg-primary'
  };

  const profile = JSON.parse(localStorage.getItem('profile'));
  const isOnWaitlist =
    event.waitlisted &&
    event.waitlisted.some(w => w.identifier === profile.identifier);
  const bgClass = isOnWaitlist
    ? colorClasses.warning
    : colorClasses[event.color] || 'bg-secondary';
  const [showModal, setShowModal] = useState(false);
  const [showWaitlistDialog, setShowWaitlistDialog] = useState(false);
  const [showErrorDialog, setShowErrorDialog] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const isCancellationTooLate = (date, time, cancellationPolicyHours) => {
    const eventDateTime = new Date(`${date}T${time}`);
    const now = new Date();
    const hoursDifference = (eventDateTime - now) / (1000 * 60 * 60);
    return hoursDifference < cancellationPolicyHours;
  };
  const handleCancelBooking = () => {
    // Here you would call your booking service to cancel the booking
    console.log(
      `Canceling booking for class: ${event.identifier} -  ${event.name} at ${event.time} on ${event.date}`
    );

    ClassService.cancelBooking({ identifier: event.identifier })
      .then(response => {
        console.log('Booking canceled successfully:', response);
        if (
          isCancellationTooLate(
            event.date,
            event.time,
            event.cancellationPolicyHours
          )
        ) {
          console.error('Cancellation is too late');
          setErrorMessage(
            'Cancellation is too late, next time please try to cancel your booking at least +' +
              event.cancellationPolicyHours +
              ' hours before the class starts.'
          );
          setShowErrorDialog(true);
        }
        handleRefreshEvents(); // Refresh the events after canceling
      })
      .catch(error => {
        console.error('Error canceling booking:', error);
      });
    // For now, we'll just log the action and close the modal
  };
  const isOnAttendeeList =
    event.attendees &&
    event.attendees.some(
      attendee =>
        attendee.identifier ===
        JSON.parse(localStorage.getItem('profile')).identifier
    );

  const handleBookClass = () => {
    console.log(
      `Booking class: ${event.identifier} -  ${event.name} at ${event.time} on ${event.date}`
    );

    if (
      event.attendees.some(
        attendee =>
          attendee.identifier ===
          JSON.parse(localStorage.getItem('profile')).identifier
      )
    ) {
      console.error('You have already booked this class');
      return;
    }

    // Check if class is full
    if (event.attendees.length >= event.maxCapacity) {
      console.log('Class is fully booked, showing waitlist dialog');
      setShowModal(false);
      setShowWaitlistDialog(true);
      return;
    }

    ClassService.bookClass({ identifier: event.identifier })
      .then(response => {
        console.log('Class booked successfully:', response);
        handleRefreshEvents();
        setErrorMessage('');
      })
      .catch(error => {
        setErrorMessage(error.message);
        setShowErrorDialog(true);
      });
  };

  const handleJoinWaitlist = () => {
    ClassService.bookClassOnWaitlist({ identifier: event.identifier })
      .then(response => {
        console.log('Added to waitlist successfully:', response);
        setShowWaitlistDialog(false);
        handleRefreshEvents();
      })
      .catch(error => {
        console.error('Error joining waitlist:', error);
      });
  };
  return (
    <>
      <Modal show={showErrorDialog} onHide={() => setShowErrorDialog(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Sorry but...</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>{errorMessage}</p>
        </Modal.Body>
      </Modal>
      {!multiple && (<Card
        className={`${bgClass} text-white border-0 cursor-pointer h-100`}
        style={{
          cursor: 'pointer',
          borderLeft: `4px solid ${
            event.color === 'gray'
              ? '#6c757d'
              : event.color === 'success'
              ? '#00d97e'
              : '#39afd1'
          }`
        }}
        onClick={() => {
          onClick && onClick(event);
          setShowModal(true);
        }}
      >
      <Card.Body className="p-2">
          <div className="fw-bold mb-1" style={{ fontSize: '0.9rem' }}>
            {event.name}
          </div>
          <div style={{ fontSize: '0.75rem' }}>{event.time}</div>
          <div style={{ fontSize: '0.75rem' }}>
            <b>{event.coach}</b>
          </div>
          <div style={{ fontSize: '0.75rem', textAlign: 'right' }}>
            {event.booked}/{event.capacity}
            {event.waitlisted && event.waitlisted.length > 0 && (
              <span className="ms-1">+{event.waitlisted.length}</span>
            )}
          </div>
        </Card.Body>
      </Card>)}
      {multiple && (<Card
        className={`${bgClass} text-white border-0 cursor-pointer h-20 mb-2`}
        style={{
          cursor: 'pointer',
          borderLeft: `4px solid ${
            event.color === 'gray'
              ? '#6c757d'
              : event.color === 'success'
              ? '#00d97e'
              : '#39afd1'
          }`
        }}
        onClick={() => {
          onClick && onClick(event);
          setShowModal(true);
        }}
      >
      <Card.Body className="p-2">
          <div className="fw-bold mb-1" style={{ fontSize: '0.9rem' }}>
            {event.name}
          </div>
          <div style={{ fontSize: '0.75rem' }}>{event.time} - <b>{event.coach}</b></div>
          <div style={{ fontSize: '0.75rem', textAlign: 'right' }}>
            {event.booked}/{event.capacity}
            {event.waitlisted && event.waitlisted.length > 0 && (
              <span className="ms-1">+{event.waitlisted.length}</span>
            )}
          </div>
        </Card.Body>
      </Card>)}
      {/* Waitlist Dialog Modal */}
      <Modal
        show={showWaitlistDialog}
        onHide={() => setShowWaitlistDialog(false)}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Join Waitlist</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>
            This class is currently full. Would you like to join the waitlist?
          </p>
          <p>You'll be notified if a spot becomes available.</p>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={() => setShowWaitlistDialog(false)}
          >
            Cancel
          </Button>
          <Button variant="warning" onClick={handleJoinWaitlist}>
            Join Waitlist
          </Button>
        </Modal.Footer>
      </Modal>
      <Modal
        show={showModal}
        centered
        onHide={() => {
          setShowModal(false);
        }}
      >
        <Modal.Header closeButton>
          <Modal.Title>{event.name}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {/* Event details content will go here */}
          <p>Time:{event.time}</p>
          <p>Coach: {event.coach}</p>
          {event.attendees && (
            <p>
              Who's going:
              <AvatarGroup dense>
                {event.attendees.map(({ avatar, firstName, identifier }) => {
                  return (
                    <Avatar
                      src={avatar || defaultAvatar}
                      key={identifier}
                      tooltip={firstName}
                      name={firstName}

                      isExact
                      size="2xl"
                      className="border border-3 rounded-circle border-light"
                    />
                  );
                })}
              </AvatarGroup>
            </p>
          )}
          {!isOnAttendeeList && (
            <Button
              variant="success"
              onClick={() => {
                handleBookClass();
                setShowModal(false);
              }}
              className="btn btn-sm"
            >
              Book Class
            </Button>
          )}
          {isOnAttendeeList && (
            <Button
              variant="danger"
              onClick={() => {
                handleCancelBooking();
                setShowModal(false);
              }}
              className="btn btn-sm"
            >
              Cancel Booking
            </Button>
          )}
          <Button
            variant="secondary"
            onClick={() => setShowModal(false)}
            className="btn btn-sm mx-2"
          >
            Cancel
          </Button>
        </Modal.Body>
      </Modal>
    </>
  );
};

const Timetable = () => {
  const { breakpoints } = useBreakpoints();
  // On mobile devices we only want to show the Day view
  const isMobile = breakpoints.down('md');
  const [showSpinner, setShowSpinner] = useState(true);

  const [view, setView] = useState('week'); // 'day' | 'week'
  const [weekStart, setWeekStart] = useState(
    startOfWeek(new Date(), { weekStartsOn: 1 })
  );
  const [selectedDay, setSelectedDay] = useState(new Date());

  // Force Day view whenever we're on a mobile viewport
  useEffect(() => {
    if (isMobile && view !== 'day') {
      setView('day');
    }
  }, [isMobile]); // eslint-disable-line react-hooks/exhaustive-deps

  // Add the Code Here - Format days with proper labels
  const days = useMemo(() => {
    if (view === 'day') {
      const date = selectedDay;
      return [
        {
          key: format(date, 'yyyy-MM-dd'),
          dateLabel: format(date, 'do MMMM'),
          dayLabel: format(date, 'EEE'),
          date
        }
      ];
    }

    return Array.from({ length: 7 }, (_, i) => {
      const date = addDays(weekStart, i);
      const dayOfMonth = format(date, 'do MMMM');
      const dayOfWeek = format(date, 'EEE');

      return {
        key: format(date, 'yyyy-MM-dd'),
        dateLabel: dayOfMonth,
        dayLabel: dayOfWeek,
        date
      };
    });
  }, [view, selectedDay, weekStart]);

  const handlePrevWeek = () => {
    if (view === 'day') {
      setSelectedDay(prev => addDays(prev, -1));
    } else {
      setWeekStart(prev => addDays(prev, -7));
    }
  };

  const handleNextWeek = () => {
    if (view === 'day') {
      setSelectedDay(prev => addDays(prev, 1));
    } else {
      setWeekStart(prev => addDays(prev, 7));
    }
  };

  const handleEventClick = event => {
    // Eventually, we are going to add some action on the Card body but don't worry about it now
    console.log('Event clicked:', event);
  };
  const [events, setEvents] = useState([]);

  // Derive the list of time slots directly from the events (classes)
  // retrieved via ClassService.retrieveAllClassesByAccount(), using each
  // class's startTime (falling back to endTime if startTime isn't set).
  const times = useMemo(() => {
    const uniqueTimes = new Set(
      events.map(e => e.startTime || e.time || e.endTime).filter(Boolean)
    );
    return Array.from(uniqueTimes).sort((a, b) => a.localeCompare(b));
  }, [events]);

  useEffect(() => {
    ClassService.retrieveAllClassesByAccount()
      .then(data => {
        const updatedEvents = data.map(d => ({
          ...d,
          time: d.startTime,
          booked: d.attendees ? d.attendees.length : 0,
          capacity: d.maxCapacity
        }));
        console.log('Updated Events:', updatedEvents);
        setEvents(updatedEvents);
        setShowSpinner(false);
      })
      .catch(error => console.error(error));
  }, []);

  const refreshEvents = () => {
    ClassService.retrieveAllClassesByAccount()
      .then(data => {
        const updatedEvents = data.map(d => ({
          ...d,
          time: d.startTime,
          booked: d.attendees ? d.attendees.length : 0,
          capacity: d.maxCapacity
        }));
        console.log('Updated Events:', updatedEvents);
        setEvents(updatedEvents);
      })
      .catch(error => console.error(error));
  };
  return (
    <>
      <Card>
        <Card.Header className="bg-white border-bottom">
          {/* Header with navigation and tabs */}
          <Row className="align-items-center">
            <Col xs="auto">
              {!isMobile && (
                <div className="d-flex gap-3">
                  <span
                    className={
                      view === 'day' ? 'fw-bold text-primary' : 'text-muted'
                    }
                    style={{
                      borderBottom:
                        view === 'day' ? '2px solid #2c7be5' : 'none',
                      cursor: 'pointer'
                    }}
                    onClick={() => setView('day')}
                  >
                    DAY
                  </span>
                  <span
                    className={
                      view === 'week' ? 'fw-bold text-primary' : 'text-muted'
                    }
                    style={{
                      borderBottom:
                        view === 'week' ? '2px solid #2c7be5' : 'none',
                      cursor: 'pointer'
                    }}
                    onClick={() => setView('week')}
                  >
                    WEEK
                  </span>
                  <span className="text-muted" style={{ cursor: 'pointer' }}>
                    MONTH
                  </span>
                </div>
              )}
            </Col>
            <Col className="text-center">
              <div className="d-flex align-items-center justify-content-center gap-3">
                <span
                  className="text-primary"
                  style={{ cursor: 'pointer', fontSize: '1.2rem' }}
                  onClick={handlePrevWeek}
                >
                  ‹‹
                </span>
                <h5 className="mb-0 text-uppercase">
                  {view === 'day'
                    ? format(selectedDay, 'MMMM d, yyyy')
                    : `${format(weekStart, 'MMMM d')} – ${format(
                        addDays(weekStart, 6),
                        'd'
                      )}`}
                </h5>
                <span
                  className="text-primary"
                  style={{ cursor: 'pointer', fontSize: '1.2rem' }}
                  onClick={handleNextWeek}
                >
                  ››
                </span>
              </div>
            </Col>
            <Col xs="auto">
              <i
                className="fas fa-filter text-primary"
                style={{ cursor: 'pointer' }}
              ></i>
            </Col>
          </Row>
        </Card.Header>
        <Card.Body className="p-0">
          {showSpinner && (
            <Alert variant="info" className="d-flex align-items-center">
              <Spinner animation="border" size="sm" className="me-2" />
              Loading classes, please wait...
            </Alert>
          )}

          {/* Timesheet grid layout */}
          <div className="table-responsive">
            <div
              style={{
                display: 'grid',
                gridTemplateColumns: `80px repeat(${days.length}, minmax(150px, 1fr))`,
                gap: '0'
              }}
            >
              {/* Empty top-left corner */}
              <div
                className="border-end border-bottom bg-light"
                style={{ position: 'sticky', left: 0, zIndex: 2 }}
              ></div>

              {/* Days header */}
              {days.map(day => (
                <div
                  key={day.key}
                  className="text-center p-3 border-end border-bottom bg-light"
                  style={{ position: 'sticky', top: 0, zIndex: 1 }}
                >
                  <div className="fw-bold">{day.dateLabel}</div>
                  <div className="text-muted small">{day.dayLabel}</div>
                </div>
              ))}

              {/* Time slots and events */}
              {times.map(time => (
                <React.Fragment key={time}>
                  {/* Time column */}
                  <div
                    className="p-2 border-end border-bottom bg-light text-end fw-bold"
                    style={{ position: 'sticky', left: 0, zIndex: 1 }}
                  >
                    {time}
                  </div>

                  {/* Day columns */}
                  {days.map(day => {
                    const filteredEvents = events.filter(
                      e => e.date === day.key && e.time === time
                    );

                    const event = events.find(
                      e => e.date === day.key && e.time === time
                    );

                    return (
                      <div
                        key={`${day.key}-${time}`}
                        className="border-end border-bottom p-2"
                        style={{
                          minHeight: '80px'
                        }}
                      >
                        {filteredEvents && filteredEvents.length > 1 && filteredEvents.map(event => (
                          <ClassCard
                            key={event.identifier}
                            event={event}
                            onClick={handleEventClick}
                            handleRefreshEvents={refreshEvents}
                            multiple={filteredEvents.length > 1}
                          />
                        ))}
                        {filteredEvents && filteredEvents.length === 1 && (
                          <ClassCard
                            key={filteredEvents[0]?.identifier}
                            event={filteredEvents[0] || null}
                            onClick={handleEventClick}
                            handleRefreshEvents={refreshEvents}
                          />
                        )}
                      </div>
                    );
                  })}
                </React.Fragment>
              ))}
            </div>
          </div>
        </Card.Body>
      </Card>
    </>
  );
};

export default Timetable;
